import { transformUrl } from 'Lib/SmartImageLib/utils';
import { isDataSavingMode, isGoodConnection } from 'Lib/utils/networkCondition';

type Options = {
  webp?: boolean;
};

export const getEffectiveUrls = (urls: string[], options?: Options) => {
  let urlsToDownload = urls;
  if (isGoodConnection() || isDataSavingMode()) {
    // don't progressively download image if connection is good or user are in data saving mode
    urlsToDownload = [urlsToDownload[urlsToDownload.length - 1]];
  }

  // transform url to webp
  if (options?.webp) {
    urlsToDownload = urlsToDownload.map((url) => transformUrl(url, true));
  }

  return urlsToDownload;
};
